<template>
  <div class="category-list__wrapper mb-6">
    <!-- items -->
    <v-row v-if="items.length > 0">
      <v-col cols="12">
      <category-post v-for="(item, i) in items" :key="i" :post="item" secondary class="mb-6"
        :id="item.id"
        :title="item.title"

      ></category-post>
      </v-col>
    </v-row>
    <!-- pages -->
    <v-row v-if="items.length > 1">
      <v-col cols="12" :class="isFirstPage ? 'd-flex justify-end' :  'd-flex justify-space-between'">
        <v-btn v-if="hasPrevPage" text  :href="prevPage" class="accent my-3 px-8">Prev</v-btn>
        <v-btn v-if="hasNextPage" text  :href="nextPage" class="accent my-3 px-8">Next</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'CategoryList',

    props: {
      category: {
        type: String,
        default: ""
      },
      categoryLink: {
        type: String,
        default: '#'
      },
      currentPage: {
        type: String,
        default: ''
      },
      featuredPosts: {
        type: Array,
        default: () => []
      },
      nextPage: {
        type: String,
        default: null
      },
      numberOfItems: {
        type: Number,
        default: 10
      },
      page: {
        type: Number,
        default: 1
      },
      prevPage: {
        type: String,
        default: ''
      },
      title: {
        type: [String, Boolean],
        default: false
      },
    },

    computed: {
      excludedIds() {
        return _.map(this.featuredPosts, 'ID')
      },
      hasNextPage() {
        return this.nextPage !== this.currentPage && ! this.isLastPage
      },
      hasPrevPage() {
        return this.prevPage !== this.currentPage
      },
      isFirstPage() {
        return this.page == 1
      },
      isLastPage() {
        return this.page == this.totalPages
      },
      featuredItem() {
        return _.head(this.items)
      },
      justifyClass() {
        return this.isFirstPage ? 'd-flex justify-end' :  'd-flex justify-space-between'
      },
      otherItems() {
        return this.isFirstPage ? this.items.slice(1,this.numberOfItems) : this.items
      }
    },

    data: () => ({
      items: [],
      totalItems: 0,
      totalPages: 0
    }),

    methods: {
      getCategoryPosts(category, page) {
        this.$axios.get('/wp-json/wp/v2/posts?categories=' + category + '&page=' + page + '&_embed=1')
        .then(response => {
          this.totalItems = response.headers['x-wp-total'];
          this.totalPages = response.headers['x-wp-totalpages'];
          this.items = response.data
        })
      },
      handleExcerpt(post) {
        return post.post_excerpt ? post.post_excerpt : post.post_content.substr(0, 300)
      }
    },

    mounted() {
      this.getCategoryPosts(this.category, this.page)
    }
  }
</script>